export const ModuleContext = 'context';
export const ModuleOption = "option";
export const ModuleEmployee = "employee";
export const ModuleLayout = "layout";
export const ModuleOrganizationUnit = "organization_unit";
export const ModuleAsset = "asset";

/**
 * Danh sách module của chương trình
 */
export const AppModules = [
	ModuleContext,
	ModuleOption,
	ModuleEmployee,
	ModuleLayout,
	ModuleOrganizationUnit,
	ModuleAsset
];
